import { ValidationLevel, ValidationResults } from '../../types'

export const countValidationResultsByLevel = ({
  validationResults,
  level
}: {
  validationResults: ValidationResults
  level: ValidationLevel
}): number => {
  return Object.keys(validationResults).reduce((allNodesTotal, nodeId) => {
    const nodeTotal = Object.keys(validationResults[nodeId]).reduce(
      (nodeTotal, configKey) => {
        const fieldTotal = validationResults[nodeId][configKey].filter(
          result => result.level === level
        ).length

        return nodeTotal + fieldTotal
      },
      0
    )

    return allNodesTotal + nodeTotal
  }, 0)
}
